<div class="wrapper">
	<app-header></app-header>
	<app-sidebar class="container-buffer"></app-sidebar>
	<main class="page-content">
		<router-outlet (activate)="onActivate($event)"></router-outlet>
	</main>
</div>

